import { Module } from 'vuex';
import { ReceivedAnswer } from '@/shared/model/resolution/receivedAnswer.model';

export const receivedAnswerStore: Module<any, any> = {
  state: {
    receivedAnswer: new ReceivedAnswer(),
  },
  getters: {
    receivedAnswer: state => state.receivedAnswer,
  },
  mutations: {
    setReceivedAnswer(state, newReceivedAnswer) {
      state.receivedAnswer = newReceivedAnswer;
    },
    cleanReceivedAnswer(state) {
      state.receivedAnswer = new ReceivedAnswer();
    },
  },
};
